import { useHttpsCallable } from "react-firebase-hooks/functions";
import { useEffect, useState } from "react";
import { functions } from "@poseidon/firebase/firebase";

export const useStartAgreement = (agreementId) => {
  const [executeCallable, saving, error] = useHttpsCallable(
    functions,
    "startAgreement"
  );
  const [complete, setComplete] = useState(false);
  useEffect(() => {
    setComplete(false);
  }, [agreementId]);
  const startAgreement = async () => {
    try {
      await executeCallable({ agreementId });
      setComplete(true);
    } catch (err) {
      setComplete(false);
    }
  };
  return {
    saving,
    error,
    success: !saving && !error && complete,
    startAgreement,
  };
};
